var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuPeopleInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-858.000000, -315.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(858.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_People_Inactive",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7 C10.119,7 9,5.824 9,4.375 L9,2.625 C9,1.175 10.119,0 11.5,0 C12.881,0 14,1.175 14,2.625 L14,4.375 C14,5.824 12.881,7 11.5,7 Z M13,9 C14.657,9 16,10.343 16,12 L16,13 C16,13.552 15.553,14 15,14 C14.447,14 14,13.552 14,13 L14,12 C14,11.447 13.553,11 13,11 L10,11 C9.447,11 9,10.553 9,10 C9,9.447 9.447,9 10,9 L13,9 Z M4.5,9 C3.119,9 2,7.824 2,6.375 L2,4.625 C2,3.175 3.119,2 4.5,2 C5.881,2 7,3.175 7,4.625 L7,6.375 C7,7.824 5.881,9 4.5,9 Z M6,11 C7.657,11 9,12.343 9,14 L9,15 C9,15.552 8.552999,16 8,16 C7.447,16 7,15.552 7,15 L7,14 C7,13.447 6.553,13 6,13 L3,13 C2.447,13 2,13.447 2,14 L2,15 C2,15.552 1.553,16 1,16 C0.447,16 0,15.552 0,15 L0,14 C0,12.343 1.343,11 3,11 L6,11 Z M10.993,3 L10.993,4 C10.993,4.553 10.947,5 11.5,5 C12.053,5 12.007,4.553 12.007,4 L12.007,3 C12.007,2.447 12.053,2 11.5,2 C10.947,2 10.993,2.447 10.993,3 Z M3.993,5 L3.993,6 C3.993,6.553 3.947,7 4.5,7 C5.053,7 5.007,6.553 5.007,6 L5.007,5 C5.007,4.447 5.053,4 4.5,4 C3.947,4 3.993,4.447 3.993,5 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuPeopleInactive);
export default __webpack_public_path__ + "static/media/Icon-Menu_People_Inactive.fe01c08e6fee01d6002b6aebfa065f09.svg";
export { ForwardRef as ReactComponent };